import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TokenService } from '../services/token.service';
import { LoginService } from '../services/login.service';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(
    private router: Router,
    private tokenService: TokenService,
    private loginService: LoginService
  ) {}

  /**
   * Protege las rutas de administrador validando contra el backend (administrator/check_admin/)
   * que el usuario autenticado realmente tiene rol de admin.
   *
   * Si no hay token, o el backend indica que no es admin, o la petición falla,
   * se saca al usuario al login.
   */
  canActivate(): Observable<boolean> {
    const token = this.tokenService.getToken();
    if (!token) {
      this.router.navigate(['/login']);
      return of(false);
    }

    return this.loginService.checkAdmin().pipe(
      map((data: any) => {
        if (data && data.is_admin) {
          return true;
        }
        this.router.navigate(['/login']);
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }
}
